export const RuruIcon = ({ size = 24, className = "" }) => (
  <svg width={size} height={size} viewBox="2.75 3 18.5 18.5" fill="currentColor" className={className} aria-hidden="true" data-testid="ruru-icon">
    <path d="M5.6 12.4c-1.7.6-2.4 2.7-1.9 4.8.3 1.3 1.1 2.4 2.3 2.9-.5-1.7-.6-4.3-.4-7.7z" />
    <path d="M18.4 12.4c1.7.6 2.4 2.7 1.9 4.8-.3 1.3-1.1 2.4-2.3 2.9.5-1.7.6-4.3.4-7.7z" />
    <path stroke="#fff" strokeWidth="0.8" d="M12 5.9c3.4 0 5.6 2.3 5.6 5.4 0 1-.2 1.9-.5 2.7.4 1 .5 2 .5 2.9 0 2-1.6 3.2-5.6 3.2s-5.6-1.2-5.6-3.2c0-.9.1-1.9.5-2.9-.3-.8-.5-1.7-.5-2.7 0-3.1 2.2-5.4 5.6-5.4z" />
    <path d="M4.8 3.6c2.1 1.7 4.5 2.5 7.2 2.5s5.1-.8 7.2-2.5c-.2 2.1-1.4 3.6-3.1 4.4H7.9C6.2 7.2 5 5.7 4.8 3.6z" />
    <circle cx="9.6" cy="9.9" r="2.3" fill="#fff" />
    <circle cx="14.4" cy="9.9" r="2.3" fill="#fff" />
    <circle cx="9.6" cy="9.9" r="1.45" />
    <circle cx="14.4" cy="9.9" r="1.45" />
    <g fill="none" stroke="#fff" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11.3 12.3l.7 1.1.7-1.1" />
      <path d="M9.9 14.6c.5.5 1.1.5 1.5 0M12.6 14.6c.5.5 1.1.5 1.5 0M9.9 16.3c.5.5 1.1.5 1.5 0M12.6 16.3c.5.5 1.1.5 1.5 0M10 18c.5.4 1 .4 1.4 0M12.6 18c.5.4 1 .4 1.4 0" />
    </g>
    <path d="M10.2 20h.7v1h-.7zM11.1 20h.7v1h-.7zM12.2 20h.7v1h-.7zM13.1 20h.7v1h-.7z" />
    <rect x="6" y="20.8" width="12" height="0.7" rx="0.35" />
  </svg>
);
